import { OrganizationMode, SubscriptionInterval, TeacherMode, Term } from '@platform-frontend/checkout-drop-in';
import { OneTimePurchaseKind, ProductIdentifier, SubscriptionKind } from '@platform-frontend/marketplace';
import { LocaleStartParams } from '@platform-frontend/transloco';

export interface RefreshAcademicRegistrationMessageParams extends GeneralStartMessageParams {
  productIdentifier: ProductIdentifier;
  start: StartAcademicRegistrationPreference | null;
}

export type StartAcademicRegistrationPreference = StartStudentMode | TeacherMode | OrganizationMode;

export interface StartStudentMode {
  type: 'STUDENT';
}

export interface RefreshCheckoutMessageParams extends GeneralStartMessageParams {
  productIdentifier: ProductIdentifier;
  contractId: string | null;
  start: StartCheckoutPreference | null;
}

export interface StartCheckoutPreference {
  quantity: number | null;
  kind: OneTimePurchaseKind<Term | null> | SubscriptionKind<SubscriptionInterval | null> | null;
}

export interface GeneralStartMessageParams extends LocaleStartParams {
  metadataId: string | null;
}

export interface RefreshSignInMessageParams extends GeneralStartMessageParams {
  vendorId: string | null;
}
